import { useTranslation } from "react-i18next";
import "../../styles/mapStyles/GeolocationStatus.css";

// Loading spinner for when location is being fetched
export function LocationLoading() {
  const { t } = useTranslation();
  return (
    <div className="geo-status-container">
      <div className="geo-status-icon">
        <div className="geo-spinner" />
      </div>
      <h2 className="geo-status-title">{t("geolocation.gettingYourLocation")}</h2>
      <p className="geo-status-message">
        {t("geolocation.pleaseWaitDetectLocation")}
      </p>

        <p className="geo-status-fix">
          {t("geolocation.makeSureLocationEnabled")}
          <br/>
          <br/>
          🌐 {t("geolocation.chromeLocationDelay")}
        </p>
        
    </div>
  );
}

// When the browser doesn't support geolocation at all
export function LocationNotSupported() {
  const { t } = useTranslation();
  return (
    <div className="geo-status-container">
      <div className="geo-status-icon geo-icon-error">
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="30" stroke="currentColor" strokeWidth="3" />
          <path d="M20 20L44 44M44 20L20 44" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
        </svg>
      </div>
      <h2 className="geo-status-title">{t("geolocation.browserNotSupported")}</h2>
      <p className="geo-status-message">
        {t("geolocation.browserDoesNotSupportGeolocation")}
      </p>
      <ul className="geo-status-reasons">
        <li>{t("geolocation.outdatedBrowser")}</li>
        <li>{t("geolocation.geolocationPermanentlyDisabled")}</li>
        <li>{t("geolocation.browserDoesNotSupportFeature")}</li>
      </ul>
      <p className="geo-status-fix">
        {t("geolocation.switchToModernBrowser")}
      </p>
    </div>
  );
}

// When the user has denied location access
export function LocationDenied() {
  const { t } = useTranslation();
  return (
    <div className="geo-status-container">
      <div className="geo-status-icon geo-icon-warning">
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M32 6C18 6 6 18 6 32s12 26 26 26 26-12 26-26S46 6 32 6z" stroke="currentColor" strokeWidth="3" />
          <path d="M32 18v18" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
          <circle cx="32" cy="44" r="2" fill="currentColor" />
        </svg>
      </div>
      <h2 className="geo-status-title">{t("geolocation.locationAccessDenied")}</h2>
      <p className="geo-status-message">
        {t("geolocation.locationAccessDisabled")}
      </p>
      <ul className="geo-status-reasons">
        <li>{t("geolocation.clickedBlockPermission")}</li>
        <li>{t("geolocation.permissionsOffInBrowser")}</li>
        <li>{t("geolocation.deviceLocationDisabled")}</li>
        <li>{t("geolocation.incognitoRestrictsLocation")}</li>
      </ul>
      <p className="geo-status-fix">
        {t("geolocation.fixLocationDenied")}
      </p>
    </div>
  );
}

// When geolocation throws a specific error
export function LocationError({ message }) {
  const { t } = useTranslation();
  return (
    <div className="geo-status-container">
      <div className="geo-status-icon geo-icon-error">
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M32 6L58 54H6L32 6z" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />
          <path d="M32 26v12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
          <circle cx="32" cy="44" r="2" fill="currentColor" />
        </svg>
      </div>
      <h2 className="geo-status-title">{t("geolocation.locationError")}</h2>
      <p className="geo-status-message">Error: {message}</p>
      <ul className="geo-status-reasons">
        <li>{t("geolocation.internetUnstable")}</li>
        <li>{t("geolocation.requestTimedOut")}</li>
        <li>{t("geolocation.gpsWeak")}</li>
        <li>{t("geolocation.locationHardwareIssue")}</li>
      </ul>
      <p className="geo-status-fix">
        {t("geolocation.refreshOrMoveArea")}
      </p>
    </div>
  );
}